var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMauritius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94556 8.34781L16.0001 9.73913L30.0547 8.34781C27.341 3.37431 22.0648 0 16.0001 0C9.93543 0 4.65924 3.37431 1.94556 8.34781V8.34781Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94544 23.6521L16 25.0434L30.0546 23.6521C31.2948 21.3789 32 18.7718 32 16L16 14.6086L0 16C0 18.7718 0.705188 21.3789 1.94544 23.6521Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.94544 8.3479C0.705188 10.6211 0 13.2282 0 16.0001H32C32 13.2282 31.2948 10.6211 30.0546 8.3479H16H1.94544Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 31.9999C22.0648 31.9999 27.341 28.6256 30.0547 23.6521H1.94556C4.65924 28.6256 9.93543 31.9999 16.0001 31.9999Z",
    fill: "#6DA544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritius);
export default __webpack_public_path__ + "static/media/mauritius.2859eeac.svg";
export { ForwardRef as ReactComponent };